export const savings_importance_section ={
    title: 'Epargnes Et Importance',
    id: 'savings_importance'
}

export const savings_introduction = "Conformément à la loi et ses textes internes, FASOCRED est une Coopérative d’épargne et de crédit. Ces deux principales activités sont encadrées par des politiques. L'épargne est la partie du revenu (sous forme liquide) des sociétaires, qui, pendant une période donnée, n'est pas dépensée. De façon générale, FASOCRED fonctionne sur la base d'intermédiation. L'épargne collectée étant redistribuée sous forme de crédit, la politique de crédit est élaborée sur la base d'une épargne collectée au préalable. "

export const savings_importance = [
    "Financement et durabilité : la collecte de l'épargne permet de tendre vers l'indépendance financière de l'institution d'épargne-crédit",
    "Responsabilisation des membres : Il s'agit de promouvoir un sentiment d'appropriation de FASOCRED par les membres.",
    "La sécurité : L’objectif de FASOCRED est de sécuriser l’épargne de ses membres en leur permettant de se prémunir contre les risques de vol ou d'incendie à leur domicile ou encore le gaspillage",
    "Les intérêts engendrés : Les épargnes telles que les Dépôts à terme (DAT) permettent aux membres de bénéficier d’intérêts",
    "L'épargne permet de mobiliser des ressources pour les membres désirant des crédits"  
]

export const savings_types_section = {
    id: 'savings_types',
    title: 'Type De Produit D’épargne'
}

export const savings_types = [{
    title: "Épargne régulière ou sur carnet d’épargne",
    details: [
        "Montant de l’épargne et montant des dépôts librement fixés par l’épargnant.",
        "Retraits souples.",
        "Peut ou ne peut pas produire des intérêts."
    ]
},{
    title: "Épargne contractuelle (Également connu sous le nom de « dépôt, accumulé, compte de dépôt, ou Compte tontine »)",
    details: [
        "Dépôt régulier d’un montant fixe pendant une durée définie d’avance. Le client peut décider de combien épargner et pour quelle durée (en choisissant parmi une gamme d'échéances fixées à l'avance).",
        "Accès restreint à l’épargne jusqu’à l’échéance du contrat.",
        "Pénalité payée pour retrait avant le terme du contrat.",
        "Peut faire emprunt garanti par votre épargne."
    ]
},{
    title: "Dépôt à terme",
    details: [
        "Montant fixe pour une durée et un taux d’intérêt déterminés d’avance.",
        "Requiert un dépôt minimum.",
        "Inflexible.",
        "Paie un taux d’intérêt plus élevé que l’épargne sur livret ou l’épargne contractuelle pour le même montant d’épargne."
    ]
},{
    title: "Epargne solidaire",
    details: [
        "Montant fixe",
        "Epargne préalable pour être membre de plein droit"
    ]
},{
    title: "Epargne nantie",
    details: [
        "Montant fonction du crédit sollicité 15 %.",
        "Epargne préalable pour bénéficier de crédit"
    ]
},{
    title: "Epargne santé",
    details: [
        "Montant fixe déposé par mois pour la question de santé",
        "Epargne préalable pour bénéficier de crédit  santé"
    ]
}]

export const dat_rates_section = {
    id: 'dat_rates',
    title: 'Grille De Taux Des DAT FASOCRED'
}

export const dat_rates = [{
    amounts: '100.000 à 4.999.000 FCFA',
    three_six_months: '2,75 %',
    six_months_one_year: '3 %',
    one_three_years: '3,1 %',
    three_five_years: '3,15 %',
    above_five_years: '3,2 %'
},{
    amounts: '5.000.000 à 9.999.999 FCFA',
    three_six_months: '2,85 %',
    six_months_one_year: '3,05 %',
    one_three_years: '3,15 %',
    three_five_years: '3,20 %',
    above_five_years: '3,25 %'
},{
    amounts: '10.000.000 à 19.999.999 CFA',
    three_six_months: '2,90 %',
    six_months_one_year: '3,10 %',
    one_three_years: '3,20 %',
    three_five_years: '3,25 %',
    above_five_years: '3,30 %'
},{
    amounts: '20.000.000 à 49.999.999 CFA',
    three_six_months: '2,95 %',
    six_months_one_year: '3,15 %',
    one_three_years: '3,25 %',
    three_five_years: '3,30 %',
    above_five_years: '3,35 %'
},{
    amounts: '50.000.000 à 99.999.999',
    three_six_months: '3 %',
    six_months_one_year: '3,20 %',
    one_three_years: '3,3 %',
    three_five_years: '3,35 %',
    above_five_years: '3,4 %'
},{
    amounts: '100.000.000 CFA et plus ',
    three_six_months: '3,1 %',
    six_months_one_year: '3,30 %',
    one_three_years: '3,4 %',
    three_five_years: '3,45 %',
    above_five_years: '3,5 %'
}]

export const tontines_accounts_section = {
    id: 'tontines_accounts',
    title: 'Les Comptes Tontines'
}

export const tontines_accounts_introduction = 'FASOCRED met à la disposition de ses membres des comptes tontines afin de leur permettre de faire des cotisations à court terme. En effet il existe deux types de cotisation tontine à FASOCRED. Il s’agit entre autre de la cotisation tontine journalière et celle hebdomadaire. La cotisation tontine journalière consiste à laisser un montant fixe au choix du membre à verser par jour. Le retrait est possible à la fin de chaque mois de cotisation. Un retrait avant terme est sujet d’une pénalité à hauteur de frais de gestion mensuel. La cotisation tontine hebdomadaire consiste à laisser un montant fixe au choix du client à verser par semaine. Le retrait est aussi possible à la fin de chaque mois de cotisation. Un retrait avant terme est sujet d’une pénalité à hauteur de frais de gestion mensuel. '

export const daily_tontines_rates = {
    title: 'Grille de tarification de la cotisation tontine journalière.',
    contributions: [
        {
            amount: '500 à 999 FCFA',
            management_fees: '250 FCFA'
        },{
            amount: '1.000 à 2.499 FCFA',
            management_fees: '500 FCFA'
        },{
            amount: '2.500 à 4.999 FCFA',
            management_fees: '1.000 FCFA'
        },{
            amount: '5.000 à 9.999 FCFA',
            management_fees: '2.000 FCFA'
        },{
            amount: '10.000 à 19.999 FCFA',
            management_fees: '5.000 FCFA'
        },{
            amount: '20.000 et plus FCFA',
            management_fees: '10.000 FCFA'
        }
    ]
}

export const weekly_tontines_rates = {
    title: 'Grille de tarification de la cotisation tontine hebdomadaire',
    contributions: [
        {
            amount: '5.000 à 9.999 FCFA',
            management_fees: '500FCFA'
        },
        {
            amount: '10.000 à 19.999 FCFA',
            management_fees: '750 FCFA'
        },
        {
            amount: '20.000 à 49.999 FCFA',
            management_fees: '1.500 FCFA'
        },
        {
            amount: '50.000 FCFA et plus',
            management_fees: '10.000 FCFA'
        }
    ]
}